import bemCnFast from 'bem-cn-fast';

function createTextCn(theme) {
  if (!theme) {
    throw new TypeError('theme argument is required');
  }

  function textCn(type = 'ktl-text-1', params = {
    paragraphOffsetAuto: false,
    hardness: undefined,
    external: false,
    mode: undefined
  }) {
    return bemCnFast(type)({
      'paragraph-offset-auto': params.paragraphOffsetAuto,
      hardness: params.hardness,
      external: params.external,
      mode: params.mode,
      theme
    });
  }

  return textCn;
}

export { createTextCn };
